import Vue from 'vue'
import VueI18n from 'vue-i18n'
import hu from 'vuetify/lib/locale/hu'
import messagesHU from '@/i18n/messages/hu'
import validationHU from 'vee-validate/dist/locale/hu.json'
import fieldsHU from '@/i18n/fields/hu'
import typesHU from '@/i18n/types/hu'
import reportsHU from '@/i18n/reports/hu'
import en from 'vuetify/lib/locale/en'
import messagesEN from '@/i18n/messages/en'
import validationEN from 'vee-validate/dist/locale/en.json'
import fieldsEN from '@/i18n/fields/en'
import typesEN from '@/i18n/types/en'
import reportsEN from '@/i18n/reports/en'
import de from 'vuetify/lib/locale/de'
import messagesDE from '@/i18n/messages/de'
import validationDE from 'vee-validate/dist/locale/de.json'
import fieldsDE from '@/i18n/fields/de'
import typesDE from '@/i18n/types/de'
import reportsDE from '@/i18n/reports/de'
import sk from 'vuetify/lib/locale/sk'
import messagesSK from '@/i18n/messages/sk'
import validationSK from 'vee-validate/dist/locale/sk.json'
import fieldsSK from '@/i18n/fields/sk'
import typesSK from '@/i18n/types/sk'
import reportsSK from '@/i18n/reports/sk'
import cs from 'vuetify/lib/locale/cs'
import messagesCS from '@/i18n/messages/cs'
import validationCS from 'vee-validate/dist/locale/cs.json'
import fieldsCS from '@/i18n/fields/cs'
import typesCS from '@/i18n/types/cs'
import reportsCS from '@/i18n/reports/cs'
import pl from 'vuetify/lib/locale/pl'
import messagesPL from '@/i18n/messages/pl'
import validationPL from 'vee-validate/dist/locale/pl.json'
import fieldsPL from '@/i18n/fields/pl'
import typesPL from '@/i18n/types/pl'
import reportsPL from '@/i18n/reports/pl'
import fr from 'vuetify/lib/locale/fr'
import messagesFR from '@/i18n/messages/fr'
import validationFR from 'vee-validate/dist/locale/fr.json'
import fieldsFR from '@/i18n/fields/fr'
import typesFR from '@/i18n/types/fr'
import reportsFR from '@/i18n/reports/fr'
import it from 'vuetify/lib/locale/it'
import messagesIT from '@/i18n/messages/it'
import validationIT from 'vee-validate/dist/locale/it.json'
import fieldsIT from '@/i18n/fields/it'
import typesIT from '@/i18n/types/it'
import reportsIT from '@/i18n/reports/it'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'hu',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: {
    en: {
      ...messagesEN,
      $vuetify: en,
      validation: validationEN.messages,
      fields: fieldsEN,
      types: typesEN,
      rpt: reportsEN,
    },
    hu: {
      ...messagesHU,
      $vuetify: hu,
      validation: validationHU.messages,
      fields: fieldsHU,
      types: typesHU,
      rpt: reportsHU,
    },
    de: {
      ...messagesDE,
      $vuetify: de,
      validation: validationDE.messages,
      fields: fieldsDE,
      types: typesDE,
      rpt: reportsDE,
    },
    sk: {
      ...messagesSK,
      $vuetify: sk,
      validation: validationSK.messages,
      fields: fieldsSK,
      types: typesSK,
      rpt: reportsSK,
    },
    cs: {
      ...messagesCS,
      $vuetify: cs,
      validation: validationCS.messages,
      fields: fieldsCS,
      types: typesCS,
      rpt: reportsCS,
    },
    pl: {
      ...messagesPL,
      $vuetify: pl,
      validation: validationPL.messages,
      fields: fieldsPL,
      types: typesPL,
      rpt: reportsPL,
    },
    fr: {
      ...messagesFR,
      $vuetify: fr,
      validation: validationFR.messages,
      fields: fieldsFR,
      types: typesFR,
      rpt: reportsFR,
    },
    it: {
      ...messagesIT,
      $vuetify: it,
      validation: validationIT.messages,
      fields: fieldsIT,
      types: typesIT,
      rpt: reportsIT,
    },
  },
})
